/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2COrderHistoryDetailData } from './aaa_b2c_order_history_detail.data';
import { IAaa_b2c_order_history_detailProps } from './aaa_b2c_order_history_detail.props.autogenerated';
import { getRequestOrderHistoryB2CAsync } from '../../dataActions/DataActionExtension.g';
import moment from 'moment';

export interface IAaa_b2c_order_history_detailViewProps extends IAaa_b2c_order_history_detailProps<IAaaB2COrderHistoryDetailData> {
    requestOrderDetail: any;
    isLoading: boolean;
}

/**
 *
 * Aaa_b2c_order_history_detail component
 * @extends {React.PureComponent<IAaa_b2c_order_history_detailProps<IAaaB2COrderHistoryDetailData>>}
 */
class Aaa_b2c_order_history_detail extends React.PureComponent<IAaa_b2c_order_history_detailProps<IAaaB2COrderHistoryDetailData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            requestOrderDetail: {},
            isLoading: true
        };
    }

    public async componentDidMount(): Promise<void> {
        const params = new URLSearchParams(this.props.context.request.url.requestUrl.search);
        var requestOrderId: string | null = '';
        var lineNum: string | null = '';
        if (params.has('requestOrderId') && params.has('lineNum')) {
            // check url has recordId...
            requestOrderId = params.get('requestOrderId');
            lineNum = params.get('lineNum');
        }
        await this.getRequestOrder(requestOrderId, lineNum);
    }

    public getRequestOrder = async (requestOrderId: any, lineNum: any) => {
        const response: any = await getRequestOrderHistoryB2CAsync(
            {
                callerContext: this.props.context.actionContext,

                queryResultSettings: {}
            },
            requestOrderId
        );

        if (response.RequestOrder.length > 0) {
            // mapping data....
            const requestOrders = response.RequestOrder.filter((order: any) => {
                return order.RequestOrderId === requestOrderId && order.LineNum.toString() === lineNum;
            });
            requestOrders.map((order: any) => {
                const requestOrderDetail: any = {
                    imageUrl: order.HighResImageURL,
                    productName: order.ProductName,
                    stockistInfo: { name: order.b2BCUSTOMERNAME, phoneNumber: order.B2BPhone, email: order.B2BEmailId },
                    statusName: order.StatusName,
                    snapShotId: order.Snapshotid,
                    orderNumber: order.RequestOrderId,
                    orderDate: order.DateTime ? moment(order.DateTime).format('DD/MM/YYYY') : '-',
                    rings: [],
                    totalPrice: order.B2CPrice.toLocaleString()
                };
                const requestOrderLines = JSON.parse(order.RequestOrderLines);
                for (const ring of requestOrderLines) {
                    const ringSizePi = parseFloat(ring.RingSize.split('mm')[0]) / 3.14159265;
                    const ringInfo = {
                        name: ring.DetailName,
                        alloy: ring.Alloy1,
                        engravingFont: ring.EngravingText ? ring.EngravingFont : '-',
                        sizeLabel: ring.RingSizeLabel,
                        sizeValue:
                            Math.round(
                                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                                (ringSizePi + Number.EPSILON) * 100
                            ) / 100,
                        engravingCopy: ring.EngravingText ? ring.EngravingText : '-',
                        specifications: ring.DiamondCount
                            ? `${ring.DiamondCount} Diamonds, ${ring.RingWidth} Wide, ${ring.RingHeight} thick`
                            : `${ring.RingWidth} Wide, ${ring.RingHeight} thick`,
                        price: ring.B2CPrice.toLocaleString()
                    };
                    requestOrderDetail.rings.push(ringInfo);
                }
                this.setState({ requestOrderDetail, isLoading: false });
            });
        }
    };

    public render(): JSX.Element | null {
        const viewProps: IAaa_b2c_order_history_detailViewProps = {
            ...(this.props as IAaa_b2c_order_history_detailProps<IAaaB2COrderHistoryDetailData>),
            requestOrderDetail: this.state.requestOrderDetail,
            isLoading: this.state.isLoading
        };
        return this.props.renderView(viewProps) as React.ReactElement;
    }
}

export default Aaa_b2c_order_history_detail;
